import { render } from "./MoolngPopover.vue?vue&type=template&id=2b674831&scoped=true"
import script from "./MoolngPopover.vue?vue&type=script&lang=js"
export * from "./MoolngPopover.vue?vue&type=script&lang=js"

import "./MoolngPopover.vue?vue&type=style&index=0&id=2b674831&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b674831"]])

export default __exports__